import React from 'react';
import { Alert, Card, Space, Tabs, Typography } from 'antd';
import { EntityAttachmentsCard } from '@/components/documents/EntityAttachmentsCard';
import {
  DOCUMENT_ENTITY_TYPE_EPC_ESTIMATE_REVISION,
  SCM_ATTACHMENT_UPLOAD_HINT,
} from '@/constants/document-entity-types';

const { Text } = Typography;

export interface EpcEstimateEvidencePanelProps {
  estimateId: string;
  revisionId: string;
  readOnly?: boolean;
}

/**
 * EST3 UX2 Wave 8 — Evidence attachments (REUSE EntityAttachmentsCard; revision-scoped).
 */
export const EpcEstimateEvidencePanel: React.FC<EpcEstimateEvidencePanelProps> = ({
  estimateId,
  revisionId,
  readOnly,
}) => (
  <Space direction="vertical" style={{ width: '100%' }} size="middle">
    <Alert
      type="info"
      showIcon
      message="Revision evidence"
      description="Files attach to this revision via platform documents (entity type epc_estimate). One file binds to one context — multi-link manifests are a later-wave SCHEMA_GAP."
    />
    <Tabs
      items={[
        {
          key: 'revision',
          label: 'Current revision',
          children: (
            <EntityAttachmentsCard
              entityType={DOCUMENT_ENTITY_TYPE_EPC_ESTIMATE_REVISION}
              entityId={revisionId}
              title="Revision evidence"
              readOnly={readOnly}
              queryKeyPrefix={['epc-est-docs', 'revision']}
              uploadHint={SCM_ATTACHMENT_UPLOAD_HINT}
            />
          ),
        },
        {
          key: 'estimate',
          label: 'Estimate header',
          children: (
            <EntityAttachmentsCard
              entityType={DOCUMENT_ENTITY_TYPE_EPC_ESTIMATE_REVISION}
              entityId={estimateId}
              title="Estimate-level documents"
              readOnly={readOnly}
              queryKeyPrefix={['epc-est-docs', 'estimate']}
              uploadHint={SCM_ATTACHMENT_UPLOAD_HINT}
            />
          ),
        },
      ]}
    />
    <Text type="secondary">
      BOQ line technical attachments remain on individual BOQ rows (MFG pattern). Subcontract quote
      evidence is captured via soft-linked supplier quotations.
    </Text>
  </Space>
);
